<mat-progress-bar
  class="app-progress-bar"
  mode="determinate"
  [color]="'accent'"
  [value]="loader.value$ | async"
  [hidden]="(loader.value$ | async) === 0"
></mat-progress-bar>
<ng-container
  *ngIf="!loggedOut && (user_authenticated$ | async) && isAppHeaderVisible && currentRoute !== '/user/login'"
>
  <global-nav class="global-nav" [skipLinkUrl]="skipLinkPath" (resize)="storeHeaderHeight($event)" />
  <ten-breadcrumb
    *ngIf="componentData?.layout === 'default' || (componentData?.layout === 'modern' && currentRoute !== '/landing')"
  >
  </ten-breadcrumb>
</ng-container>

<ten-logged-out-nav *ngIf="(user_authenticated$ | async) === false && !this.showContentOutsideNav"></ten-logged-out-nav>
<ten-logged-out-nav-content
  *ngIf="(user_authenticated$ | async) === false && this.showContentOutsideNav"
></ten-logged-out-nav-content>

<div
  class="page-container"
  [ngClass]="{
    'extra-padding': componentData?.layout !== 'modern' && (user_authenticated$ | async) === false,
  }"
>
  <div id="main-content" class="main-content" [class.holding-page]="isHoldingPage">
    <mat-spinner class="loader" *ngIf="loaderService.displayed$ | async; else outlet"></mat-spinner>
    <ng-template #outlet>
      <router-outlet></router-outlet>
    </ng-template>
  </div>
</div>

<tour-step-template>
  <ng-template let-step="step">
    <mat-card
      class="tour-modal"
      (click)="$event.stopPropagation()"
      [style.margin-top.px]="step.marginTop"
      [dir]="direction"
      *ngIf="step"
      (keyup.enter)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      (keydown.tab)="$event.stopPropagation()"
      (keydown.shift.tab)="$event.stopPropagation()"
      tabindex="-1"
    >
      <div id="tour-focus-trap" tabindex="-1" cdkTrapFocus>
        <div class="tour-title" [tabindex]="step.title ? 0 : -1">{{ step.title }}</div>
        <mat-card-content>
          <div [innerHtml]="step?.content" [tabindex]="step.content ? 0 : -1"></div>
        </mat-card-content>
        <div *ngIf="onFinalTourStep">
          <mat-checkbox aria-label="Show quick tour again next time I login" [(ngModel)]="showTourAgain"></mat-checkbox>
          &nbsp;
          <span aria-hidden="true" [translate]="'SpotlightTour:ShowAgain'"
            >Show quick tour again next time I login</span
          >
        </div>
        <mat-card-actions *ngIf="tourService.steps.indexOf(tourService.currentStep) + 1 as currentStep">
          <span class="pagination-steps">{{ currentStep + ' / ' + tourService.steps.length }}</span>
          <div class="pagination-buttons">
            <button
              mat-icon-button
              aria-label="previous"
              [disabled]="!tourService.hasPrev(step)"
              (click)="tourService.prev()"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
            <button
              mat-icon-button
              aria-label="next"
              [disabled]="!tourService.hasNext(step)"
              (click)="tourService.next()"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
          <button
            *ngIf="!onFinalTourStep"
            aria-label="skip"
            mat-flat-button
            color="primary"
            (click)="endSiteTour(true)"
          >
            {{ 'OnBoardingPopup:Skip' | translate }}
          </button>
          <button *ngIf="onFinalTourStep" aria-label="end" mat-flat-button color="primary" (click)="endSiteTour(false)">
            {{ 'OnBoardingPopup:End' | translate }}
          </button>
        </mat-card-actions>
      </div>
    </mat-card>
  </ng-template>
</tour-step-template>

<div
  id="js-backdrop"
  style="position: fixed; display: none; box-shadow: rgba(0, 0, 0, 0.7) 0 0 0 9999px; z-index: 100"
></div>

<ten-sitemap-footer *ngIf="showFooterSiteMap && (user_authenticated$ | async)"></ten-sitemap-footer>

<global-footer
  *ngIf="!showFooterSiteMap && !componentData.customTenFooter && !componentData.customMtlsFooter"
  [class.holdingpage-footer]="isHoldingPage ? true : null"
  [dcrCookieLanguage]="dcrCookieLanguage"
  [userAuthenticated$]="user_authenticated$"
></global-footer>

<ten-concierge-footer
  *ngIf="componentData.customTenFooter && !componentData.customMtlsFooter"
  [dcrCookieLanguage]="dcrCookieLanguage"
  [userAuthenticated$]="user_authenticated$"
></ten-concierge-footer>

<ten-mtls-footer *ngIf="componentData.customMtlsFooter"></ten-mtls-footer>

<ng-container *ngIf="siteSettings$ | async as siteSettings">
  <ten-chat
    *ngIf="siteSettings.switches.show_genesys_web_messenger && (user$ | async).isAuthenticated"
    [genesysWebMessengerEnabled]="siteSettings.switches.show_genesys_web_messenger"
    [genesysChatData]="genesysChatData$ | async"
  ></ten-chat>
</ng-container>
